const sizeUtil = (space) => {
    const scale = (() => {
        switch (space) {
            case "office-meeting-room":
                return 2.2;
            case "bedroom":
                return 2;
            case "판매 B":
                return 2.4;
            case "판매 C":
                return 3.6;
            case "의료 A":
                return 1.8;
            case "의료 B":
                return 2;
            case "의료 C":
                return 1.6;
            case "교육 C":
                return 1.6;
            case "주거 A":
                return 2;
            case "주거 B":
                return 1.9;
            case "주거 C":
                return 2.5;
            case "hallway":
                return 7;
            case "교육 A":
                return 5;
            case "교육 B":
                return 2;
            case "사무 B":
                return 2;
            case "사무 C":
                return 2.4;
            default:
                return 1;
        }
    })();
    const ratio = (() => {
        switch (space) {
            case "교육 A":
                return 0.1;
            case "교육 B":
                return 0.25;
            case "사무 B":
                return 0.15;
            case "사무 C":
                return 0.15;
            case "주거 A":
                return 0.2;
            case "주거 B":
                return 0.18;
            case "주거 C":
                return 0.18;
            case "bedroom":
                return 0.25;
            case "판매 A":
                return 0.3;
            case "판매 B":
                return 0.17;
            case "판매 C":
                return 0.1;
            case "cafe":
                return 0.28;
            case "사무 A":
                return 0.45;
            case "rehabilitation-room":
                return 0.13;
            case "의료 A":
                return 0.2;
            case "의료 C":
                return 0.14;
            case "office-meeting-room":
                return 0.1;
            case "의료 B":
                return 0.17;
            case "hallway":
                return 0.1;
            case "교육 C":
                return 0.18;
            default:
                return 0.49;
        }
    })();
    const transform = (() => {
        switch (space) {
            case "office-meeting-room":
                return `rotateX(90deg) rotateZ(-35deg) translateY(-10%) translateX(25%) translateZ(-200px) scale(${scale})`;
            case "hallway":
                return `rotateX(90deg) rotateZ(0.9deg) translateY(-330%) scale(${scale})`;
            case "주거 A":
                return `rotateX(90deg) translateZ(-200px) translateX(9%) translateY(-50%)  scale(${scale})`;
            case "주거 B":
                return `rotateX(90deg) rotateZ(37deg) translateZ(-250px) scale(${scale})`;
            case "주거 C":
                return `rotateX(90deg) rotateZ(-35deg) translateZ(-500px) translateY(-70%) scale(${scale})`;
            case "bedroom":
                return `rotateX(90deg) rotateZ(-17.5deg) translateY(-80%) scale(${scale})`;
            case "판매 B":
                return `rotateX(80deg) translateZ(-500px) translateY(-100%) translateX(-20%)  scale(${scale})`;
            case "판매 C":
                return `rotateX(90deg) translateZ(-550px) rotateZ(-27deg) translateX(90%) translateY(-150%) scale(${scale})`;
            case "의료 A":
                return `rotateX(80deg) rotateZ(-19deg) translateZ(-400px) translateX(25%) translateY(-40%) scale(${scale})`;
            case "교육 C":
                return `rotateX(90deg) rotateZ(-15deg) translateX(10%) translateY(10%) scale(${scale});`;
            case "의료 B":
                return `rotateX(90deg) rotateZ(15deg) translateZ(-380px) translateY(-63%) translateX(-50%) scale(${scale});`;
            case "의료 C":
                return `rotateX(90deg) rotateZ(-53deg) translateZ(-200px) translateY(6%) scale(${scale});`;
            case "교육 A":
                return `rotateX(90deg) translateX(-38%) translateZ(-500px) translateY(-240%) scale(${scale});`;
            case "교육 B":
                return `rotateX(90deg) rotateZ(-11deg) translateY(-20%) translateZ(-250px) scale(${scale});`;
            case "사무 B":
                return `rotateX(90deg) rotateZ(51deg) translateX(-10%) translateZ(-100px) scale(${scale});`;
            case "사무 C":
                return `rotateX(90deg) rotateZ(49deg) translateZ(-290px) translateY(-38%) translateX(-20%) scale(${scale});`;
            default:
                return;
        }
    })();
    const height = (() => {
        switch (space) {
            case "교육 A":
                return "300%";
            case "교육 B":
                return "150%";
            case "사무 B":
                return "200%";
            case "사무 C":
                return "200%";
            case "bedroom":
                return "200%";
            case "hallway":
                return "350%";
            case "주거 A":
                return "300%";
            case "주거 C":
                return "200%";
            case "판매 C":
                return "300%";
            case "의료 A":
                return "200%";
            case "판매 B":
                return "200%";
            case "의료 B":
                return "100%";
            case "교육 C":
                return "150%";
            default:
                return `100%`;
        }
    })();
    const width = (() => {
        switch (space) {
            case "hallway":
                return "500%";
            case "주거 A":
                return "200%";
            case "의료 A":
                return "200%";
            case "living-room":
                return "200%";
            case "판매 B":
                return "200%";
            case "의료 B":
                return "200%";
            case "교육 C":
                return "150%";
            case "hallway":
                return `100%`;
            default:
                return `100%`;
        }
    })();
    const perspectiveOrigin = (() => {
        switch (space) {
            case "교육 B":
                return "54% 25%";
            case "사무 B":
                return "49% 9%";
            case "사무 C":
                return "50% 48%";
            case "office-meeting-room":
                return "0% 47%";
            case "hallway":
                return "50% 48%"
            case "living-room":
                return "50% 10%"
            case "주거 A":
                return "50% 8%";
            case "주거 B":
                return "50% 30%";
            case "주거 C":
                return "37% 20%";
            case "bedroom":
                return "50% 23%";
            case "판매 B":
                return "40% 62%";
            case "판매 C":
                return "50% 40%";
            case "의료 B":
                return "88% 22%";
            case "의료 C":
                return "50% 8%";
            case "교육 C":
                return "15% 13.5%";
            case "교육 A":
                return "48% 38%";
            default:
                return "center";
        }
    })();
    const perspective = (() => {
        switch (space) {
            case "교육 A":
                return 1000;
            case "의료 B":
                return 1500;
            case "의료 C":
                return 1600;
            case "주거 A":
                return 1200;
            case "bedroom":
                return 1000;
            case "판매 B":
                return 800;
            case "판매 C":
                return 1200;
            case "office-hallway":
                return 500;
            case "office-reception-room":
                return 500;
            case "rehabilitation-room":
                return 900;
            case "의료 A":
                return 1000;
            case "hallway":
                return 1000;
            case "departmentstore":
                return 1200;
            case "교육 C":
                return 1500;
            default:
                return 1800;
        }
    })();
    return {
        transform: transform,
        scale: scale,
        ratio: ratio,
        widht: width,
        height: height,
        perspectiveOrigin: perspectiveOrigin,
        perspective: perspective,
    }
}

export default sizeUtil;